<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">物资清单</div>
        <el-form
          class="zj-search-form clear"
          ref="form"
          :model="form"
          :label-width="labelWidth"
          v-if="isShowSearch"
        >
          <el-form-item label="物资类型">
            <el-select
              v-model="materialType"
              placeholder="请选择"
              style="width: 35rem"
            >
              <el-option>请选择</el-option>
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" - " v-if="false">
            <el-select
              v-model="subType"
              placeholder="请选择"
              style="width: 35rem"
            >
              <el-option
                v-for="item in optionsnext"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="存放仓库">
            <el-select
              v-model="warehousevalue"
              placeholder="请选择"
              style="width: 35rem"
            >
              <el-option>请选择</el-option>
              <el-option
                v-for="item in warehouselist"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物资名称">
            <el-input v-model="materialName" style="width: 35rem"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main
        style="padding-top: 0px"
        v-loading="searching"
        element-loading-text="搜索中"
      >
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onOuthouse">出 库</el-button>
              <el-button size="mini" @click="onInhouse">入 库</el-button>
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding: 0.8rem 0px 0px 0px">
            <el-table
              class="table-default"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column
                type="selection"
                prop="MaterialName"
                width="40"
                align="center"
                v-if="isShowSearch"
              ></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="MaterialName"
                label="物资名称"
              ></el-table-column>
              <el-table-column
                prop="MaterialTypeId"
                label="物资类型"
                :formatter="ConvertMaterialType"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="StockNum"
                label="库存数量"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="WarehouseText"
                label="存放仓库"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Contact"
                label="负责保管人"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="移动电话"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="ModifyTime"
                label="修改日期"
                :formatter="formatDate"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="150"
                align="center"
                v-if="isShowSearch"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <el-dialog
      v-dialogDrag
      title="物资入库"
      :visible.sync="dialogOpts.dialogTableVisible"
    >
      <ZjMaterialInWarehouse
        v-if="dialogOpts.dialogTableVisible"
        :viewData="dialogOpts.rowlist"
        :materialTypedate="materialTypedate"
        @cancel="dialogCancel"
        @ok="dialogOk"
        @search="search"
      />
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="物资出库"
      :visible.sync="dialogOpts.dialogTable2Visible"
    >
      <ZjMaterialOutWarehouse
        v-if="dialogOpts.dialogTable2Visible"
        :viewData2="dialogOpts.rowlist2"
        :materialTypedate2="materialTypedate2"
        @cancel="dialogCancel2"
        @ok="dialogOk2"
        @search="search"
      />
    </el-dialog>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import ZjMaterialInWarehouse from "./MaterialInWarehouse";
import ZjMaterialOutWarehouse from "./MaterialOutWarehouse";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjMateriallist",
  controller: "UI",
  action: "Materiallist",
  props: {
    WarehouseId: String,
    query: {
      obj: String,
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      loadingText: "加载中...",
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      materialName: "",
      options: [],
      materialType: "",
      optionsnext: [],
      subType: "",
      warehouselist: [],
      warehousevalue: "",
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null,
      },
      materialTypedate: null,
      materialTypedate2: null,
      MaterialTypeDic: [],
      isShowSearch: true,
    };
  },
  components: {
    ZjMaterialInWarehouse,
    ZjMaterialOutWarehouse,
  },
  created: function () {
    this.basedatabind();
    this.isShowSearch = this.$props.query.type == "search" ? false : true;
  },
  mounted: function () {
    this.$nextTick(() => {
      this.search();
    });
    this.logInfo.ActionName = "应急物资管理查看";
    this.logInfo.LogMessage = "应急物资管理查看";
    this.logInfo.ModuleName = "应急系统";
    this.logInfo.PageName = "应急物资管理";
    this.addOperationLog();
  },
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        this.search();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //基础数据绑定
    basedatabind() {
      //存放仓库的查询条件
      let searchInfo = {
        PageSize: 2000,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };

      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([
          this.config.getUValue("EmergencyService:MaterialType:", ""), //物资类型
          this.config.getUValue("EmergencyService:SubType:", ""), //物资子类型
          new MyApis.MaterialWareHouseApi().FindByConditions(searchInfo), //存放仓库
        ])
        .then((r) => {
          //物资类型
          this.options = r[0].JValue;
          for (var i = 0; i < this.options.length; i++) {
            var item = this.options[i];
            this.MaterialTypeDic[item.ItemKey] = item.Extend1;
          }

          //物资子类型
          this.optionsnext = r[1].JValue;

          //存放仓库
          this.warehouselist = r[2].data.Data;

          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
      this.materialTypedate = this.MaterialTypeDic;
      this.materialTypedate2 = this.MaterialTypeDic;
    },
    search() {
      let searchInfo = {};
      if (
        this.$props.WarehouseId == "" ||
        this.$props.WarehouseId == null ||
        this.$props.WarehouseId == undefined
      ) {
        searchInfo = {
          MaterialTypeId: this.materialType,
          WarehouseId: this.warehousevalue,
          MaterialName: this.materialName,
          PageSize: this.pageSize,
          PageIndex: this.currentPage,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
      } else {
        searchInfo = {
          WarehouseId: this.$props.WarehouseId,
          PageSize: this.pageSize,
          PageIndex: this.currentPage,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
      }

      this.searching = true;
      new MyApis.MaterialsApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.searching = false;
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.searching = false;
        });
    },

    clearsearch() {
      this.materialName = "";
      this.materialType = "";
      this.subType = "";
      this.warehousevalue = "";
    },

    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },

    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          obj: row.MaterialId,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          obj: row.MaterialId,
          type: "search",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          obj: "",
          type: "edit",
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (this.selectData != undefined) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const selectData = this.selectData;
          const count = selectData.length;
          // 清除 所有勾选项
          this.$refs.multipleTable.clearSelection();
          if (count > 0) {
            this.loading = true;
            this.loadingText = "删除中...";
            new MyApis.MaterialsApi()
              .DelItemList(selectData)
              .then((r) => {
                r = r.data.Data;
                if (r) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "删除失败!",
                  });
                }
                this.loading = false;
                this.logInfo.ActionName = "应急物资删除";
                this.logInfo.LogMessage = r
                  ? "应急物资删除成功"
                  : "应急物资删除失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急物资列表页面";
                this.addOperationLog();
                this.search();
              })
              .catch((e) => {
                console.error(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "删除失败！");
                this.loading = false;
              });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.MaterialsApi()
          .DelItem(row)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.logInfo.ActionName = "应急物资删除";
            this.logInfo.LogMessage = r
              ? "应急物资删除成功"
              : "应急物资删除失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资列表页面";
            this.addOperationLog();
            this.search();
          })
          .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "删除失败！");
            this.loading = false;
          });
      });
    },
    //入库按钮
    onInhouse() {
      if (this.selectData != undefined && this.selectData.length > 0) {
        this.dialogOpts.dialogTableVisible = true;
      } else {
        this.$message({
          type: "info",
          message: "请选择要入库的数据！",
        });
      }
    },
    //出库按钮
    onOuthouse() {
      if (this.selectData != undefined && this.selectData.length > 0) {
        for (var i = 0; i < this.selectData.length; i++) {
          var item = this.selectData[i];
          if (item.StockNum <= 0) {
            this.$message({
              type: "info",
              message: "选择的库存[" + item.MaterialName + "]数量不足",
            });
            return;
          }
        }
        this.dialogOpts.dialogTable2Visible = true;
      } else {
        this.$message({
          type: "info",
          message: "请选择要出库的数据！",
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.MaterialTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogOk2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
    dialogCancel2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
  },
};
</script>
<style lang="css" scoped>
.table-default /deep/.el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
</style>

